import { render } from "./chart_cross.vue?vue&type=template&id=cb7c7b12&scoped=true"
const script = {}

import "./chart_cross.vue?vue&type=style&index=0&id=cb7c7b12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7c7b12"]])

export default __exports__